import { Map } from "immutable";

import syncDocumentTypes from "../../constants/syncDocumentTypes";
import immutableRecords from "../../types/immutableRecords";

const syncDocumentFromNarrativeRoot = (externalId, label) => {
  return immutableRecords.SyncDocumentRecord({
    id: externalId,
    type: syncDocumentTypes.DRAFT_FOLDER,
    label,
    properties: Map({
      title: label
    })
  });
};

export default syncDocumentFromNarrativeRoot;
